import { IFI_Freemius_Checkout_Settings } from 'classes/interface.freemius-checkout';
import { Freemius_Checkout } from './classes/class.freemius-checkout';

// Add a reference to the global parameters
declare global {
	var aelia_freemius_integration_frontend_params: IFI_Freemius_Checkout_Settings;
	var jQuery: any;
	// Global Freemius Scripts instance
	// @since 0.5.3.210324
	var FS: any;
}

(function ready(callback, args) {
  if(document.readyState != 'loading'){
		// If this function is called after the document has finished loading,
		// invoke the callback immediately
		callback(args);
	}
	else {
		// If the document is still loading, trigger the callback on the
		// "DOM loaded" event
		document.addEventListener('DOMContentLoaded', () => callback(args));
  }
})(Freemius_Checkout.init, aelia_freemius_integration_frontend_params);
